import { useState } from 'react'

import { PanelBox, Snackbar, TitlePaper } from '../default'
import { BypassCustomersTable } from '../tables'

const BypassCustomersPanel = () => {

    const [snackbarData, setSnackbarData] = useState({ open: false, severity: 'success', message: '' })

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') return
        setSnackbarData({ ...snackbarData, open: false })
    }

    return (
        <PanelBox title='Clientes em Exceção'>
            <TitlePaper
                title='Tabela de Clientes em Exceção'
                subtitle='Lista de clientes que não sofrem alterações aplicadas pelas políticas de crédito'
            >
                <BypassCustomersTable setSnackbarData={setSnackbarData} />
            </TitlePaper>

            <Snackbar
                open={snackbarData.open}
                onClose={handleSnackbarClose}
                message={snackbarData.message}
                severity={snackbarData.severity}
            />
        </PanelBox>
    )
}

export default BypassCustomersPanel
